const TERMS_LINK =
  "https://myrepapp-assets.s3-us-west-1.amazonaws.com/terms.pdf";
const PRIVACY_LINK =
  "https://myrepapp-assets.s3-us-west-1.amazonaws.com/privacy.pdf";

export { TERMS_LINK, PRIVACY_LINK };
